export default class Group {
  constructor() {
    this.axles = [];
  }

  draw(ctx, violation) {
    let color = '#000000';
    if (violation === 'No') { color = '#00FF00'; }
    if (violation === 'Yes') { color = '#FF0000'; }

    this.axles.forEach(axle => axle.draw(ctx, color));
  }

  centerX() {
    if (this.axles.length === 1) { return this.axles[0].x; }

    return (this.axles[this.axles.length - 1].x + this.axles[0].x) / 2;
  }

  description() {
    return this.type() + ' [' + this.axles.map(el => el.number).join(', ') + ']';
  }

  type() {
    if (this.axles.length === 1) {
      return 'Single axle';
    }
    if (this.axles.length === 2) {
      return 'Tandem axle';
    }
    if (this.axles.length === 3) {
      return 'Tridem axle';
    }
    if (this.axles.length === 4) {
      return 'Quadrum axle';
    }
    if (this.axles.length === 5) {
      return 'Five axles group';
    }

    return 'Axle of unknown type';
  }
};
